import React from 'react'
import { push } from 'redux-first-router'

export const usePuppeteerGoto = () => {
  React.useEffect(() => {
    // Exposes redux router on the global namespace so that puppeteer
    // can change routes without reloading the entire application
    window.goto = url => push(new URL(url, window.location).pathname) // push new route to redux-router

    return () => delete window.goto
  })
}
